import { createContext, ReactNode, useContext, useMemo, useState } from "react";

type ThreadActivityState = {
  showActivity: boolean;
  toggleActivity: () => void;
};

const ThreadActivityContext = createContext<ThreadActivityState | null>(null);

/**
 * Wraps the header and the message list together: the action is in one and
 * the rows it reveals are rendered by the other, and they are siblings in
 * every screen that shows a thread.
 *
 * Mounted against the thread, so opening another conversation starts hidden
 * again rather than carrying the last one's view across.
 */
export function ThreadActivityProvider({ children }: { children: ReactNode }) {
  const [showActivity, setShowActivity] = useState(false);

  const value = useMemo(
    () => ({
      showActivity,
      toggleActivity: () => setShowActivity((previous) => !previous),
    }),
    [showActivity],
  );

  return (
    <ThreadActivityContext.Provider value={value}>
      {children}
    </ThreadActivityContext.Provider>
  );
}

export function useShowThreadActivity(): ThreadActivityState | null {
  return useContext(ThreadActivityContext);
}
